import type { getRevenuesParams } from 'api/v2/revenues';
import type { getExpensesParams } from 'api/v3/expenses';
import { stringify } from 'query-string';
import type { ExportEntry } from 'types/export';
import type { ExportListType } from 'types/global.types';
import api from '../../axiosInstance';

export const getExportById = (exportId: string): Promise<ExportEntry> => {
  return api.get(`/v2/exports/${exportId}`);
};

const toClassifyMapper = {
  yes: 'true',
  no: 'false',
};

const hiddenTransactionsFilterMapper = {
  yes: 'true',
  no: 'false',
};

export const exportExpenses = (
  query: getExpensesParams,
  body: ExportListType,
): Promise<any> =>
  api.post(
    `/v2/exports/expenses?${stringify(query, {
      skipEmptyString: true,
      arrayFormat: 'comma',
    })}`,
    body,
  );

export const exportRepoDocuments = (
  query: Record<string, any>,
  body: Omit<ExportListType, 'integrationId'>,
): Promise<any> =>
  api.post(
    `/v2/exports/repository-documents?${stringify(query, {
      skipEmptyString: true,
      arrayFormat: 'comma',
    })}`,
    body,
  );

export const exportRevenues = (
  query: getRevenuesParams,
  body: ExportListType,
): Promise<any> =>
  api.post(
    `/v2/exports/revenues?${stringify(query, {
      skipEmptyString: true,
      arrayFormat: 'comma',
    })}`,
    body,
  );

export const exportTransactions = (
  query: any,
  body: ExportListType,
): Promise<any> =>
  api.post(
    `/v2/exports/transactions?${stringify(
      {
        ...query,
        toClassify:
          toClassifyMapper[query.toClassify as keyof typeof toClassifyMapper],
        deleted:
          hiddenTransactionsFilterMapper[
            query.deleted as keyof typeof hiddenTransactionsFilterMapper
          ],
      },
      {
        skipEmptyString: true,
        arrayFormat: 'comma',
      },
    )}`,
    body,
  );

export const getExportHistory = () => api.get('/v2/exports');
